module.exports = __webpack_public_path__ + "asset/font-dollarbird-5725bee721bfcf9e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/style/icon/fonts/dollarbird.ttf
// module id = qJuL
// module chunks = 3